<template>
  <v-card light>
    <v-card-title>
      <TheBreadcrumbs />
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pt-0">
      <router-view></router-view>
    </v-card-text>
  </v-card>
</template>

<script>
  import TheBreadcrumbs from '../components/single/TheBreadcrumbs';

  export default {
    name: 'Page',
    components: { TheBreadcrumbs },
    methods: {
      redirectToDashboard() {
        if (this.$route.matched.length === 1) {
          this.$router.push({ name: 'dashboard' });
        }
      },
    },
    created() {
      this.redirectToDashboard();
    },
  };
</script>
